export default [
  {
    path: '/services',
    name: 'service',
    component: () => import('@/pages/Services/Selector.vue'),
    meta: { requiresAuth: true, requiresServices: [1, 2, 3, 4] }
  },
  {
    path: '/services/campaign/:service/type/:type',
    name: 'service-campaign-launch',
    component: () => import('@/pages/Services/Selector/CampaignLauncher.vue'),
    meta: { requiresAuth: true, requiresServices: [1, 2, 3, 4] }
  },
  {
    path: '/services/campaign/:service/configuration',
    name: 'service-campaign-configuration',
    component: () => import('@/pages/Services/Selector/CampaignLauncher.vue'),
    meta: { requiresAuth: true, requiresServices: [1, 2, 3, 4] }
  },
  {
    path: '/services/senders',
    name: 'service-senders',
    component: () => import('@/pages/Services/Senders.vue'),
    meta: { requiresAuth: true, requiresServices: [3] }
  },
  {
    path: '/management/supervisor',
    name: 'supervisor-dashboard',
    component: () => import('@/pages/Chat/supervisor/CampaignWhatsappCharts.vue'),
    meta: { requiresAuth: true, requiresServices: [5] }
  },
  {
    path: '/management/workgroups',
    name: 'workgroups',
    component: () => import('@/pages/Workgroups/Dashboard.vue'),
    meta: { requiresAuth: true, requiresServices: [5] }
  },
  {
    path: '/management/workgroups/:workgroup_id/settings',
    name: 'workgroups-settings',
    component: () => import('@/pages/Workgroups/components/WorkgroupSettings.vue'),
    meta: { requiresAuth: true, requiresServices: [5] }
  },
  {
    path: '/management/strategies',
    name: 'strategy-settings',
    component: () => import('@/pages/Workgroups/components/StrategySettings.vue'),
    meta: { requiresAuth: true, requiresServices: [5] }
  },
  {
    path: '/management/bots/:bot_name/flow_interactions',
    name: 'flow-interactions',
    component: () => import('@/pages/bots/BotFlowInteractions.vue'),
    meta: { requiresAuth: true, requiresServices: [5] }
  },
  {
    path: '/management/mm_lite_onboarding',
    name: 'mm_lite_onboarding',
    component: () => import('@/pages/mmLiteOnboarding.vue'),
    meta: { requiresAuth: true, requiresServices: [3] }
  },
  {
    path: '/reports/campaigns',
    name: 'reports',
    component: () => import('@/pages/Reports/Reports.vue'),
    meta: { requiresAuth: true, requiresServices: [1, 2, 3, 4] }
  },
  {
    path: '/reports/registers',
    name: 'registers',
    component: () => import('@/pages/Reports/Registers.vue'),
    meta: { requiresAuth: true, requiresServices: [1, 2, 3, 4] }
  },
  {
    path: '/reports/sms/detail/:campaign_id',
    name: 'reports-sms',
    component: () => import('@/pages/Reports/DetailSmsReport.vue'),
    meta: { requiresAuth: true, requiresServices: [1] }
  },
  {
    path: '/reports/email/detail/:campaign_id',
    name: 'reports-email',
    component: () => import('@/pages/Reports/DetailEmailReport.vue'),
    meta: { requiresAuth: true, requiresServices: [4] }
  },
  {
    path: '/reports/whatsapp/detail/:campaign_id',
    name: 'reports-whatsapp',
    component: () => import('@/pages/Reports/DetailWhatsappReport.vue'),
    meta: { requiresAuth: true, requiresServices: [3] }
  },
  {
    path: '/enviamas-documentation',
    name: 'enviamas-documentation',
    component: () => import('@/pages/Documentacion/RedirectToDocumentation.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/tools/blacklist',
    name: 'black-list',
    component: () => import('@/pages/Blacklist/Blacklist.vue'),
    meta: { requiresAuth: true, requiresServices: [3, 5] }
  },
  {
    path: '/tools/blacklist/:blacklist_id',
    name: 'black-list-element',
    component: () => import('@/pages/Blacklist/BlacklistMessages.vue'),
    meta: { requiresAuth: true, requiresServices: [3, 5] }
  },
]
